import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['info', 'hero'];

  connect() {
    this.syncHeight = this.syncHeight.bind(this);
    this.rafSync = this.rafSync.bind(this);

    this.rafId = null;

    this.setupEventListeners();
    this.setupObservers();
    this.rafSync();
  }

  disconnect() {
    window.removeEventListener('load', this.rafSync);
    window.removeEventListener('resize', this.rafSync);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.mutationObserver) this.mutationObserver.disconnect();
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }

  setupEventListeners() {
    window.addEventListener('load', this.rafSync);
    window.addEventListener('resize', this.rafSync);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.rafSync).catch(() => {});
    }
  }

  setupObservers() {
    if (typeof ResizeObserver !== 'undefined') {
      try {
        this.resizeObserver = new ResizeObserver(this.rafSync);
        this.resizeObserver.observe(this.infoTarget);

        const mainImg = this.heroTarget.querySelector('.main-img');
        if (mainImg) {
          this.resizeObserver.observe(mainImg);
        }
      } catch (e) {
        this.setupMutationObserver();
      }
    } else {
      this.setupMutationObserver();
    }
  }

  setupMutationObserver() {
    try {
      this.mutationObserver = new MutationObserver(this.rafSync);
      this.mutationObserver.observe(this.infoTarget, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
      });
    } catch (e) {
      // Empty catch
    }
  }

  rafSync() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = requestAnimationFrame(this.syncHeight);
  }

  syncHeight() {
    if (!this.hasInfoTarget || !this.hasHeroTarget) return;

    const width = window.innerWidth;

    if (width < 768) {
      this.heroTarget.style.height = '';
      const containers = this.heroTarget.querySelectorAll(':scope > div');
      containers.forEach((div) => (div.style.height = 'auto'));

      const mainImg = this.heroTarget.querySelector('.main-img');
      const secondaryImgs = this.heroTarget.querySelectorAll('.secondary-img');

      if (mainImg && secondaryImgs.length > 0) {
        const targetHeight = Math.round(mainImg.getBoundingClientRect().height);
        if (targetHeight > 0) {
          secondaryImgs.forEach((img) => {
            if (img.style.height !== targetHeight + 'px') {
              img.style.height = targetHeight + 'px';
              img.style.objectFit = 'cover';
            }
          });
        }
      }
      return;
    }

    const containers = this.heroTarget.querySelectorAll(':scope > div');
    containers.forEach((div) => (div.style.height = ''));
    const secondaryImgs = this.heroTarget.querySelectorAll('.secondary-img');
    secondaryImgs.forEach((img) => {
      img.style.height = '';
      img.style.objectFit = '';
    });

    const h = Math.max(
      0,
      Math.round(this.infoTarget.offsetHeight || 0) + 25 + 118,
    );

    if (h && this.heroTarget.style.height !== h + 'px') {
      this.heroTarget.style.height = h + 'px';
    }
  }
}
